
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code3 } from "@/views/resources/documentation/element-ui/basic/button/code";

export default defineComponent({
  name: "text-button",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code3
    };
  }
});
